import { useAction } from "@/hooks/shared";
import { acceptInvitationHandler } from "@/services";

export const useAcceptInvitation = () => useAction(acceptInvitationHandler);
